import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return {
      campaignIds: Array,
      emailAccountIds: Array,
    }
  }

  static get targets() {
    return ["messageList", "emptySpace"]
  }

  connect() {
    this.observer = new MutationObserver(this.change.bind(this))
    this.observer.observe(this.messageListTarget, { childList: true, subtree: true })
    this.change()
  }

  disconnect() {
    this.observer.disconnect()
  }

  change() {
    this.removeFilteredMessages()

    if (this.messageListTarget.querySelectorAll("turbo-frame > li").length > 0) {
      this.emptySpaceTarget.classList.add("d-none")
    } else {
      this.emptySpaceTarget.classList.remove("d-none")
    }

    this.addFiltersToMessages()

    const changeEvent = new CustomEvent("campaign--scheduled-messages:change")
    window.dispatchEvent(changeEvent)
  }

  removeFilteredMessages() {
    document.querySelectorAll("li.inbox-item").forEach(el => {
      if (this.hasCampaignIdsValue) {
        let campaignIdOfElement = el.getAttribute("data-campaign-id")

        if (!this.campaignIdsValue.includes(Number(campaignIdOfElement))) {
          el.remove()
        }
      }

      if (this.hasEmailAccountIdsValue) {
        let emailAccountIdOfElement = el.getAttribute("data-email-account-id")

        if (!this.emailAccountIdsValue.includes(Number(emailAccountIdOfElement))) {
          el.remove()
        }
      }
    })
  }

  addFiltersToMessages() {
    this.messageListTarget.querySelectorAll("turbo-frame > li > a").forEach(link => {
      let url = new URL(`http://localhost${link.getAttribute("href")}`)

      if (this.hasCampaignIdsValue) {
        url.searchParams.set("campaigns", this.campaignIdsValue)
      }

      if (this.hasEmailAccountIdsValue) {
        url.searchParams.set("email_accounts", this.emailAccountIdsValue)
      }

      let filterHref = url.href.replace(/^http:\/\/localhost\//, "/")
      link.setAttribute("href", filterHref)
    })
  }
}
